import React from "react";
import { Route, Routes } from "react-router-dom";
import { SalesVatReportPage } from "./containers";

export const SalesVatReport = () => {
  return (
    <Routes>
      <Route path="/" element={<SalesVatReportPage />} />
    </Routes>
  );
};
